// «متوسط فاتورة الكاشير» on its own screen (owner decision 2026-11-02): for someone granted
// `cashier_check_view` alone, who must see nothing else of «المبيعات». The same panel is a tab
// of «تحليلات نقاط البيع» for «المبيعات» users; here it carries its own branch filter.
import { Receipt } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { PageHeader } from "@/components/layout/PageHeader";
import PosCashierCheckPanel from "@/components/pos/PosCashierCheckPanel";
import { OPS } from "@/constants/testIds";

export default function CashierCheckPage() {
    const { t } = useI18n();
    return (
        <div data-testid={OPS.cashierCheckPage} className="space-y-5">
            {/* the description sits in the report card below, once */}
            <PageHeader icon={Receipt} title={t("pi_cc_page_title")} />
            <PosCashierCheckPanel withBranchFilter />
        </div>
    );
}
